import React from 'react';
import DraggableContainer from '../DragableContainer';
import OhanaChanNowPlaying from './styles/087Chan';

import MinimalNowPlaying from './styles/Minimal';
import MinimalMark2NowPlaying from './styles/MinimalMark2';
import NightNowPlaying from './styles/Night';
import SakuraNowPlaying from './styles/Sakura';

export enum NowPlayingStyle {
  '087Chan',
  'Minimal',
  'Night',
  'Sakura',
  'MinimalMark2',
}

export interface NowPlayingProps {
  style?: NowPlayingStyle;
  draggable?: boolean;
}

const NowPlaying: React.FC<NowPlayingProps> = ({ style, draggable = true }) => {
  let NowPlayingComponent;
  switch (style) {
    case NowPlayingStyle['087Chan']:
      NowPlayingComponent = OhanaChanNowPlaying;
      break;
    case NowPlayingStyle['Minimal']:
      NowPlayingComponent = MinimalNowPlaying;
      break;
    case NowPlayingStyle.MinimalMark2:
      NowPlayingComponent = MinimalMark2NowPlaying;
      break;
    case NowPlayingStyle.Night:
      NowPlayingComponent = NightNowPlaying;
      break;
    case NowPlayingStyle.Sakura:
      NowPlayingComponent = SakuraNowPlaying;
      break;
    default:
      NowPlayingComponent = OhanaChanNowPlaying;
      break;
  }
  if (!draggable) return <NowPlayingComponent />;

  return (
    <DraggableContainer elementKey="nowPlaying">
      <NowPlayingComponent />
    </DraggableContainer>
  );
};

export default NowPlaying;
